import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Col, Image, List, Modal, Row} from 'antd';
import styled from 'styled-components';
import StoreActions from "bukku/redux/Store/actions";
import FormatNumber from "../FormatNumber";

const {
    closeNoticeModal,
} = StoreActions;

const Styled = styled.div`
  .ant-modal-content {
    z-index: 5000;
    border-radius: 10px;
    
    .ant-modal-close-x {
      color: rgba(255, 255, 255, 80%);
    }
  }
  
  .ant-modal-header {
    background-color: #128ea1;
    border-color: #128ea1;
    border-radius: 9px 9px 0 0;

    .ant-modal-title {
      font-size: 18px;
      color: white;
    }
  }
  
  .ant-modal-body {
    height: 70vh;
    padding: 0;
    overflow-y: auto;
    background-color: #f0fffe;
    border-radius: 0 0 9px 9px;
  }

  /* Copied from CheckoutDrawer's style */
  .list-item__checkout-product {
    padding: 1em 24px;
  }
  
  .ant-list-header {
    padding: 1em 24px;
    
    h3 {
      font-size: 14px;
      font-weight: 500;
    }

    p {
      font-size: 12px;
      color: rgba(0,0,0,50%);
    }
  }

  .ant-list {
    padding-bottom: 1em;
  }
  
  .ant-list-item {
    
  }
  
  .ant-list-item:last-child {
    border-bottom: 1px solid #f0f0f0;
  }

  .ant-image {
    position: relative;
    width: 100%;
    padding-top: 100%;  /* aspect ratio 1:1 */

    /* aspect ratio 1:1 */
    .image {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .image__placeholder {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      padding: 1em;
      overflow: hidden;
      font-size: 12px;
      font-weight: 400;
      color: var(--brand-color-teal);
      text-align: center;
      background-color: var(--primary-1);
    }
  }

  .row__product-container {
    width: 100%;
  }

  .img-checkout__product {
    object-fit: contain;
  }
  
  .item-msg {
    font-weight: 500;
    color: #a8071a;
  }

  .item-old-price, .item-new-price {
    display: flex;
    flex-flow: row wrap;
    
    .item-price-text {
      position: relative;
      top: 4px;
      margin-right: 8px;
      font-size: 12px;
    }
  }
  
  .item-old-price {
    margin-top: 8px;
    opacity: 0.4;
  }

  .item-new-price {
    opacity: 0.7;
  }
`;

class StoreNoticeModal extends Component {
    renderImage = (thumbnailUrl, name) => <Image
        className="image"
        preview={thumbnailUrl}
        placeholder={<div className="image__placeholder">{name}</div>}
        src={thumbnailUrl}
    />;

    renderPriceChanges = (oldPrice, newPrice, oldUnitLabel, newUnitLabel) => {
        const { store } = this.props;
        return (
            <>
                <div className="item-new-price">
                    <FormatNumber
                        currency={store.currencySymbol}
                        amount={newPrice}
                        suffix={`/ ${newUnitLabel}`}
                    />
                </div>
                <div className="item-old-price">
                    <div className="item-price-text">Previously: </div>
                    <FormatNumber
                        currency={store.currencySymbol}
                        amount={oldPrice}
                        suffix={`/ ${oldUnitLabel}`}
                    />
                </div>
            </>
        );
    };

    renderOutOfStock = () => <div className="item-msg">Out of Stock</div>;

    renderNotAvailable = () => <div className="item-msg">Not Available</div>;

    renderListItem = ({productId, name, oldPrice, newPrice, oldUnitLabel, newUnitLabel}, type) => {
        const { productData } = this.props;
        const product = productData.find(product => product.id === productId);

        return (
            <List.Item className="list-item__checkout-product">
                <Row className="row__product-container" gutter={[12, 0]}>
                    <Col span={8}>
                        { this.renderImage(product?.thumbnailUrl, name)}
                    </Col>
                    <Col span={16}>
                        <strong>{name}</strong>
                        { type === 'price_change' ?
                            this.renderPriceChanges(oldPrice, newPrice, oldUnitLabel, newUnitLabel) :
                            null }
                        { type === 'out_of_stock' ? this.renderOutOfStock() : null }
                        { type === 'not_available' ? this.renderNotAvailable() : null }
                    </Col>
                </Row>
            </List.Item>
        );
    };

    renderList = (items, header, subtitle, type) => {
        if (items.length === 0)
            return null;

        console.log('aaa noticeModal renderList', items);

        return (
            <List header={(
                <>
                    <h3>{header}</h3>
                    <p>{subtitle}</p>
                </>
            )}
            >
                { items.map(item => this.renderListItem(item, type))}
            </List>
        );
    };

    renderProductsWithPriceChanges = () => {
        const { productsWithPriceChanges } = this.props;
        return this.renderList(
            productsWithPriceChanges,
            "Price Adjustment",
            'There are price adjustments for the following items.',
            'price_change');
    };

    renderProductsOutOfStock = () => {
        const { productsOutOfStock } = this.props;
        return this.renderList(
            productsOutOfStock,
            "Out of Stock",
            'The following items are currently out of stock, and will be removed from the shopping cart.',
            'out_of_stock');
    };

    renderProductsNotAvailable = () => {
        const { productsNotAvailable } = this.props;
        return this.renderList(
            productsNotAvailable,
            "Not Available",
            'The following items are no longer available, and will be removed from the shopping cart.',
            'not_available');
    };

    onCancel = () => {
        const { closeNoticeModal } = this.props;
        closeNoticeModal();
    };

    render() {
        const { productsWithPriceChanges, productsNotAvailable, productsOutOfStock } = this.props;

        const visible = productsWithPriceChanges.length +
         productsNotAvailable.length +
         productsOutOfStock.length > 0;

        return (
            <Styled id="bukku-store-notice-modal">
                <Modal
                    title="Notice"
                    width={400}
                    open={visible}
                    destroyOnClose
                    zIndex={2005}
                    maskStyle={{zIndex: 2005}} // higher priority then checkout confirmatin
                    footer={null}
                    onCancel={this.onCancel}
                    getContainer={() => document.getElementById('bukku-store-notice-modal')}
                >
                    { this.renderProductsWithPriceChanges() }
                    { this.renderProductsOutOfStock() }
                    { this.renderProductsNotAvailable() }
                </Modal>
            </Styled>
        );
    }
}
export default connect(state => ({
    store: state.Store.store,
    productData: state.Store.productData,
    productsWithPriceChanges: state.Store.productsWithPriceChanges,
    productsNotAvailable: state.Store.productsNotAvailable,
    productsOutOfStock: state.Store.productsOutOfStock,
}), {
    closeNoticeModal,
})(StoreNoticeModal);
